import createClient from '@economic/http-client';
import { AxiosInstance } from 'axios';

const RETRIES = 3;

let workflowsApiEndpoint: string | undefined;
let api: AxiosInstance | null = null;

export function setupWorkflowsEndpoint(path: string) {
    workflowsApiEndpoint = `${path}/api`;

    api = createClient(
        workflowsApiEndpoint,
        `${process.env.ECONOMIC_PATH}/internal-api/application/access-token`,
        'Authorization',
        'Bearer ',
        60
    );

    api.interceptors.response.use(
        response => response,
        error => {
            const { config } = error;
            const { status } = error.response;

            if (status !== 500 && status !== 429) {
                return Promise.reject(error);
            }

            if (config.retryCount === RETRIES) {
                return Promise.reject(error);
            }

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve(true);
                }, config.retryDelay || 1000);
            }).then(() => {
                if (api) {
                    config.retryCount = config.retryCount ? config.retryCount + 1 : 1;
                    config.retryDelay = config.retryCount * 2000;
                    return api(config);
                }
            });
        }
    );
}

export default function getApi() {
    if (!api) {
        throw new Error('Call setupWorkflowsEndpoint before using addons API');
    }

    return api;
}
